import $x from '@/utils/$x';

/** 获取门店校准轨迹（地图展示数据） */
export async function getCalibrationTrajectory(params) {
  return $x.post('/enterprise/store/calibration/trajectory', params);
}

/** 获取门店校准时间序列（折线图数据） */
export async function getCalibrationTimeline(params) {
  return $x.post('/enterprise/store/calibration/timeline', params);
}

/** 获取单批次校准详情（弹窗数据） */
export async function getCalibrationBatchDetail(params) {
  return $x.post('/enterprise/store/calibration/batchDetail', params);
}

/** 搜索门店（下拉建议） */
export async function searchStores(params) {
  return $x.post('/enterprise/store/calibration/search', params);
}

/** 获取门店采纳历史记录 */
export async function getAdoptionHistory(params) {
  return $x.post('/enterprise/store/calibration/adoptionHistory', params);
}
